import React from "react";
import { IconProps } from "../icon";

export const Percent_01Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 5L5 19M7.5 6.5a1 1 0 11-2 0 1 1 0 012 0zm11 11a1 1 0 11-2 0 1 1 0 012 0z"
    />
  </svg>
);
